<div>

    <div class="connect-common-page-header">

        <div class="padding-top-10 padding-bottom-5">
            <h2 class="display-block header-text semi-bold-font">Mortgage Information</h2>
            <span class="header-details" *ngIf="mortgage?.isNewMortgage()">
                <i class="fa fa-info-circle padding-right-5"></i>Please provide information concerning any new mortgage or secured line of credit for the property. You can select the "Add New Mortgage" button to add additional new mortgages.
            </span>
            <span class="header-details" *ngIf="mortgage?.isExistingMortgage()">
                <i class="fa fa-info-circle padding-right-5"></i>Please provide information concerning any existing mortgage or secured line of credit for the property. You can select the "Add Existing Mortgage" button to add additional existing mortgages.
            </span>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div class="padding-10" *ngIf="formGroup">
        <form [formGroup]="formGroup" class="padding-5">
                <div *ngIf="showMortgageDetailsStep">
                    <div class="row col-12 padding-left-0 padding-right-0" >
                        <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="bankNameFieldKey">
                            <mat-form-field >
                                <mat-label>Name of Bank</mat-label>
                                <input matInput formControlName="bankName" my-auto-focus maxlength="200">
                                <mat-error>This field is required</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="referenceNumberFieldKey">
                            <mat-form-field >
                                <mat-label>Reference No.</mat-label>
                                <input matInput formControlName="referenceNumber" maxlength="35">
                                <mat-error>This field is required</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row col-12 padding-left-0 padding-right-0" formGroupName="mortgageBroker">
                        <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="brokerNameFieldKey">
                            <mat-form-field class="padding-right-10" >
                                <mat-label>Name of Broker</mat-label>
                                <input matInput formControlName="name" maxlength="200">
                                <mat-error>This field is required</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="brokerPhoneFieldKey">
                            <ng-container formArrayName="telephones">
                                <mat-form-field class="padding-right-10" formGroupName="0" >
                                    <mat-label>Phone Number</mat-label>
                                    <input matInput formControlName="telephoneNumber" dp-phone-number>
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </ng-container>
                        </div>
                        <div class="col-12 col-lg-4 padding-left-0" [dp-field-visibility]="brokerEmailFieldKey">
                            <mat-form-field class="padding-right-10" >
                                <mat-label>Email</mat-label>
                                <input matInput formControlName="email" maxlength="100">
                                <mat-error *ngIf="formGroup.controls?.mortgageBroker.controls?.email?.errors?.email">Email must be a valid email address</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <dp-cirf-udf
                            [formGroup]="formGroup"
                            [cirfFormArrayName]="'mortgageUdfs'"
                            [cirfUdfFieldKey]="mortgageUdfFieldKey"
                            [cirfUdfs]="mortgageUdfs"
                    ></dp-cirf-udf>

                </div>
                <!-- Remove Mortgage(s) Notes into separate  page -->
                <div *ngIf="mortgage && mortgage.isExistingMortgage()">
                    <div class="padding-top-10">
                        <h3>Please Upload Mortgage Statement</h3>
                    </div>
                    <div class="padding-top-10">
                        <dp-file-upload *ngIf="!mortgageStatementDocument"
                                [sourceId]="mortgageId"
                                [documentType]="'MORTGAGE'"
                                [mortgageIndex]="mortgageIndex"
                                [mortgageType]="mortgage?.mortgageType"
                                [uploadBtnLabel]="'Upload Mortgage Statement'"
                                [documentDescription]="mortgageStatementDescription"
                                (documentUploaded)="documentUploaded($event)"
                        ></dp-file-upload>
                    </div>
                    <div class="padding-top-10">
                        <mat-list role="list">
                            <mat-list-item role="listitem" *ngFor="let document of cirfMortgageDocuments;let index=index"  (mouseenter)="hoveredIndex=index">
                                <div class="mat-card-connect-client-list-left">
                                    <mat-icon class="mat-card-connect-icon" title="{{document.description}}"
                                              *ngIf="document.isVirusClean()">attachment
                                    </mat-icon>
                                    <mat-icon class="mat-card-connect-icon" title="File is Infected"
                                              *ngIf="document.isVirusInfected()">block
                                    </mat-icon>
                                    <mat-icon class="mat-card-connect-icon" title="Virus Scan Pending"
                                              *ngIf="document.isVirusPending()">warning
                                    </mat-icon>
                                    <mat-icon class="mat-card-connect-icon" title="Virus Scan In Progress"
                                              *ngIf="document.isVirusInProgress()">warning
                                    </mat-icon>
                                    <span class="mat-card-list-text">{{document.documentName}} - {{document.description}}</span>

                                </div>
                                <div class="mat-card-connect-client-list-right" *ngIf="index==hoveredIndex">
                                    <button class="mat-card-icon" mat-icon-button
                                            (click)="deleteDocument(document)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                                <mat-divider></mat-divider>
                            </mat-list-item>
                        </mat-list>
                    </div>
                </div>

        </form>
    </div>
</div>
